<div class="card bg-dark-lighter text-white wallet-request">
  <div
    class="card-header collapsed"
    data-bs-toggle="collapse"
    attr.data-bs-target="#{{ type }}Request"
    aria-expanded="false"
    attr.aria-controls="{{ type }}Request"
  >
    <span *ngIf="type!='bitgo-deposits'">{{ type.replace(re, " ") + " Request" | uppercase }}</span>
    <span *ngIf="type=='bitgo-deposits'">{{ "BTC deposit request" | uppercase }}</span>
    <a
      class="btn-collapse collapsed ml-15"
      data-bs-toggle="collapse"
      attr.data-bs-target="#{{ type }}Request"
      aria-expanded="false"
      attr.aria-controls="{{ type }}Request"
    >
      <i class="fa fa-compress"></i>
      <i class="fa fa-expand"></i>
    </a>
    <button class="pull-right text-red fx-export-data" (click)="$event.stopPropagation(); $event.preventDefault(); exportExcel()" create-permission>
      Export
      <i class="fa fa-print"></i>
    </button>
  </div>
  <div class="card-body no-padder collapse" id="{{ type }}Request">
    <div class="p-3">
      <div class="row mb-15">
        <div class="col-md-6">
          <div
            class="input-group search-group"
            [ngClass]="{ loading: loading }"
          >
            <input
              type="text"
              class="form-control bg-dark"
              name="keyword"
              placeholder="Search Request"
              [(ngModel)]="condition.keyword"
              (keyup)="onKeyup($event)"
            />
            <button
              class="btn btn-main"
              type="button"
              (click)="searchTransaction(true)"
            >
              Search
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="table-responsive">
            <table class="rox-table table-bordered bg-dark" id="tbl{{ type }}Request">
              <thead>
                <tr>
                  <th class="text-center">ID</th>
                  <th class="text-center" *ngIf="type === 'banking-withdraws'">
                    IBID
                  </th>
                  <th class="text-center">User Name</th>
                  <th class="text-center">Email</th>
                  <th class="text-center">MT5 Account</th>
                  <th class="text-center">Currency</th>
                  <th class="text-center" *ngIf="type === 'sticpay-transactions'" >Transaction ID</th>
                  <th class="text-center">
                    {{
                      type === "banking-withdraws" ? "Nominal Volume" : type === "sticpay-transactions" ?  "Requested Amount" : "Amount"
                    }}
                  </th>
                  <th class="text-center" *ngIf="type === 'banking-withdraws'  || type === 'sticpay-transactions'">
                    Fee
                  </th>
                  <th class="text-center" *ngIf="type === 'banking-withdraws' || type === 'sticpay-transactions'">
                    {{
                      type === "banking-withdraws" ? "Actual Volume" : "Actual Amount"
                    }}
                  </th>
                  <th class="text-center">Date</th>
                  <th class="text-center" *ngIf="type == 'banking-withdraws'">
                    Status
                    <select
                      id="banking-withdraws-select"
                      class="fx-select bg-dark-lighter text-white"
                      name="ddlType"
                      [(ngModel)]="condition.status"
                      (change)="searchTransaction()"
                    >
                      <option value="">All</option>
                      <option
                        value="{{ opt.value }}"
                        *ngFor="let opt of status; let i = index"
                      >
                        {{ opt.label }}
                      </option>
                    </select>
                  </th>
                  <th class="text-center" *ngIf="type == 'sticpay-transactions'">
                    Status
                    <select
                      id="banking-withdraws-select"
                      class="fx-select bg-dark-lighter text-white"
                      name="ddlType"
                      [(ngModel)]="condition.status"
                      (change)="searchTransaction()"
                    >
                      <option value="">All</option>
                      <option
                        value="{{ opt.value }}"
                        *ngFor="let opt of statusSticpay; let i = index"
                      >
                        {{ opt.label }}
                      </option>
                    </select>
                  </th>
                  <th
                    class="text-center view-bank-widthdraws"
                    *ngIf="type === 'banking-withdraws'"
                    create-permission
                  ></th>
                  <span *ngIf="type === 'banking-withdraws'" class="d-none">
                    <th class="text-center">
                      Beneficiary's Bank Name	
                    </th>
                    <th class="text-center">
                      Beneficiary's Bank Number	
                    </th>
                    <th class="text-center">
                      Beneficiary's Bank Swift code	
                    </th>
                    <th class="text-center">
                      Beneficiary's Bank Address
                    </th>
                    <th class="text-center">
                      Beneficiary Name	
                    </th>
                    <th class="text-center">
                      Beneficiary Address
                    </th>
                  </span>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="
                    let item of data
                      | paginate
                        : {
                            id: type,
                            itemsPerPage: pageInfo.pageSize,
                            currentPage: pageInfo.pageIndex,
                            totalItems: pageInfo.totalRecord
                          }
                  "
                >
                  <td class="text-center">{{ item.id }}</td>
                  <td class="text-center" *ngIf="type === 'banking-withdraws'">
                    {{ item.ibId? item.ibId : ''}}
                  </td>
                  <td class="text-center">{{ item.getUsername() }}</td>
                  <td class="text-center">{{ item.email }}</td>
                  <td class="text-center">{{ item.login }}</td>
                  <td class="text-center">{{ item.asset | uppercase }}</td>
                  <td class="text-center" *ngIf="type === 'sticpay-transactions'">{{ item.paymentId | uppercase }}</td>
                  <td class="text-center">
                    <span
                      labelNumber="{{ item.amount }}"
                      [currency]="item.asset"
                    ></span>
                  </td>
                  <td class="text-center" *ngIf="type === 'banking-withdraws'">
                    <span
                      labelNumber="{{ item.withdrawFee }}"
                      [currency]="item.asset"
                    ></span>
                  </td>
                  <td class="text-center" *ngIf="type === 'sticpay-transactions'">
                    <span
                      *ngIf="item.status == 2"
                      labelNumber="{{ item.amount - item.actualAmount}}"
                      [currency]="item.asset"
                    ></span>
                  </td>
                  <td class="text-center" *ngIf="type === 'banking-withdraws'">
                    <span
                      labelNumber="{{ item.amount - item.withdrawFee }}"
                      [currency]="item.asset"
                    ></span>
                  </td>
                  <td class="text-center" *ngIf="type === 'sticpay-transactions'">
                    <span
                      *ngIf="item.status == 2"
                      labelNumber="{{ item.actualAmount }}"
                      [currency]="item.asset"
                    ></span>
                  </td>
                  <td class="text-center">
                    {{ item.createTime | date: "yyyy/MM/dd" }}
                  </td>
                  <td
                    class="text-center action-process {{
                      loading && pointUpdate === item.id
                        ? 'loading ignore-click'
                        : ''
                    }}"
                    *ngIf="type === 'banking-withdraws'"
                  >
                    <div
                      class="action-process__status"
                      *ngIf="item.status == 0 && permission.allowUpdating"
                    >
                      <button
                        class="btn btn-down"
                        type="button"
                        (click)="onChangeStatusProcess(item, 4)"
                      >
                        Reject
                      </button>
                      <button
                        class="btn btn-up"
                        type="button"
                        (click)="onChangeStatusProcess(item, 3)"
                      >
                        Approval
                      </button>
                    </div>
                    <ng-container *ngIf="item.status != 0">
                      {{ item.getStatus() }}
                    </ng-container>
                  </td>
                  <td class="text-center" *ngIf="type === 'sticpay-transactions'">
                    {{ item.getStatus() }}
                  </td>
                  <td
                    class="text-center action-process view-bank-widthdraws"
                    *ngIf="type === 'banking-withdraws'"
                    create-permission
                  >
                    <a
                      href="javascript:void(0)"
                      class="text-blue-lighter"
                      (click)="getBankInfo(item)"
                      data-bs-toggle="modal"
                      data-bs-target="#modalBankInfomation"
                      >View Bank</a
                    >
                  </td>
                  <div *ngIf="item.bankAccountInfo">
                    <td
                    class="d-none"
                    *ngIf="type === 'banking-withdraws'">
                    {{ item.bankAccountInfo['beneficiary_bank_name']}}
                  </td>
                  <td
                    class="d-none"
                    *ngIf="type === 'banking-withdraws'">
                    {{ item.bankAccountInfo['beneficiary_bank_number']}}
                  </td>
                  <td
                    class="d-none"
                    *ngIf="type === 'banking-withdraws'">
                    {{ item.bankAccountInfo['beneficiary_bank_swift_code']}}
                  </td>
                  <td
                    class="d-none"
                    *ngIf="type === 'banking-withdraws'">
                    {{ item.bankAccountInfo['beneficiary_bank_address']}}
                  </td>
                  <td
                    class="d-none"
                    *ngIf="type === 'banking-withdraws'">
                    {{ item.bankAccountInfo['beneficiary_name']}}
                  </td>
                  <td
                    class="d-none"
                    *ngIf="type === 'banking-withdraws'">
                    {{ item.bankAccountInfo['beneficiary_address']}}
                  </td>
                  </div>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row mt-15">
        <div class="col">
          <div class="pagination-wrapper">
            <pagination-controls
              id="{{ type }}"
              (pageChange)="pageChanged($event)"
              autoHide="true"
              responsive="true"
              previousLabel="Prev"
              nextLabel="Next"
            >
            </pagination-controls>
          </div>
        </div>
        <div class="col-auto">
          <span class="data-info"
            >Found: {{ pageInfo.totalRecord }}
            {{ pageInfo.totalRecord > 1 ? "records" : "record" }}</span
          >
        </div>
      </div>
    </div>
  </div>
  <!-- CHANGE MODAL -->
  <div
    class="modal fade fx-modal"
    id="modalBankInfomation"
    *ngIf="type === 'banking-withdraws'"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h2 class="modal-title font-bold" style="margin-bottom: 0">
            {{ bankInfo.email + " (" + bankInfo.username + ")" }}
          </h2>
          <button
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            &times;
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <table class="rox-table table-bordered bg-dark bank-info__table" *ngIf="bankInfo.data">
            <tbody>
<!--              <tr>-->
<!--                <td class="text-main w-50">Country</td>-->
<!--                <td class="text-start">-->
<!--                  <select-->
<!--                    class="w-100"-->
<!--                    [(ngModel)]="bankInfo.data.country"-->
<!--                    disabled-->
<!--                  >-->
<!--                    <option *ngFor="let item of countries" [value]="item.value">-->
<!--                      {{ item.label }}-->
<!--                    </option>-->
<!--                  </select>-->
<!--                </td>-->
<!--              </tr>-->
              <ng-container *ngIf="bankInfo.data.country == 'JP'">
                <tr>
                  <td class="text-main">Bank Name</td>
                  <td class="text-start">{{ bankInfo.data.bank_name }}</td>
                </tr>
                <tr>
                  <td class="text-main">Branch Name</td>
                  <td class="text-start">{{ bankInfo.data.branch_name }}</td>
                </tr>
                <tr>
                  <td class="text-main">Account Type</td>
                  <td class="text-start">
                    {{
                      bankInfo.data.account_type == 0
                        ? "Savings account"
                        : "Checking account"
                    }}
                  </td>
                </tr>
                <tr>
                  <td class="text-main">Branch Code</td>
                  <td class="text-start">{{ bankInfo.data.branch_code }}</td>
                </tr>
                <tr>
                  <td class="text-main">Account Number</td>
                  <td class="text-start">{{ bankInfo.data.account_number }}</td>
                </tr>
                <tr>
                  <td class="text-main">Bank account name</td>
                  <td class="text-start">
                    {{ bankInfo.data.bank_account_name }}
                  </td>
                </tr>
              </ng-container>
              <ng-container *ngIf="bankInfo.data.country != 'JP'">
                <tr>
                  <td class="text-main">Beneficiary's Bank Name</td>
                  <td class="text-start">
                    {{ bankInfo.data.beneficiary_bank_name }}
                  </td>
                </tr>
                <tr>
                  <td class="text-main">Beneficiary's Bank Number</td>
                  <td class="text-start">
                    {{ bankInfo.data.beneficiary_bank_number }}
                  </td>
                </tr>
                <tr>
                  <td class="text-main">Beneficiary's Bank Swift code</td>
                  <td class="text-start">
                    {{ bankInfo.data.beneficiary_bank_swift_code }}
                  </td>
                </tr>
                <tr>
                  <td class="text-main">Beneficiary's Bank Address</td>
                  <td class="text-start">
                    {{ bankInfo.data.beneficiary_bank_address }}
                  </td>
                </tr>
                <tr>
                  <td class="text-main">Beneficiary Name</td>
                  <td class="text-start">
                    {{ bankInfo.data.beneficiary_name }}
                  </td>
                </tr>
                <tr>
                  <td class="text-main">Beneficiary Address</td>
                  <td class="text-start">
                    {{ bankInfo.data.beneficiary_address }}
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
